import React from 'react';
import styled from 'astroturf/react';
import { TimesIcon } from 'js/social/shared/Icons';
import _Container from "AttachmentOverlay-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/attachments/AttachmentOverlay.tsx?styleId=Container";
import _RemoveButton from "AttachmentOverlay-RemoveButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/attachments/AttachmentOverlay.tsx?styleId=RemoveButton";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const RemoveButton = /*#__PURE__*/styled("div", null, {
  displayName: "RemoveButton",
  styles: _RemoveButton
});

type Props = {
  onRemove: () => void;
  className?: string;
  removable?: boolean;
};

export const AttachmentOverlay: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  onRemove,
  removable = true,
}) => {
  return (
    <Container className={className}>
      {children}

      {removable && (
        <RemoveButton
          onClick={(event) => {
            event.preventDefault();
            onRemove();
          }}
        >
          <TimesIcon />
          Remove
        </RemoveButton>
      )}
    </Container>
  );
};
